import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotValue = (formData.get('phone_alt') as string || '').trim();

    if (honeypotValue) {
      setSubmitStatus('success');
      setEmail('');
      return;
    }

    setSubmitStatus('idle');
    setFormError('');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9qrqinnahb7382ovee0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || responseText;

      if (response.ok && parsed?.code === 'OK') {
        setSubmitStatus('success');
        setEmail('');
      } else if (serverMsg && (serverMsg.includes('spam') || serverMsg.includes('form data is spam'))) {
        setSubmitStatus('error');
        setFormError(serverMsg);
      } else {
        setSubmitStatus('error');
        setFormError(serverMsg || '订阅失败，请稍后再试');
      }
    } catch {
      setSubmitStatus('error');
      setFormError('网络错误，请检查网络连接');
    }
  };

  return (
    <footer className="bg-background-900 text-background-200" role="contentinfo">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 pt-14 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-flashlight-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold font-heading text-background-50">黑料社</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              专注独家内幕、热点曝光与深度八卦的聚合平台。真实可信、内容劲爆，每日更新不断。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-300 text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-background-300 text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-background-300 text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 font-heading">热门分类</h4>
            <ul className="space-y-2">
              <li><Link to="/category/entertainment" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">娱乐圈</Link></li>
              <li><Link to="/category/influencers" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">网红圈</Link></li>
              <li><Link to="/category/business" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">商业圈</Link></li>
              <li><Link to="/category/hot-events" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热点事件</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 font-heading">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">加入我们</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 font-heading">订阅猛料</h4>
            <p className="text-sm text-background-400 mb-4">第一时间获取最新黑料，不错过任何劲爆内幕</p>
            <form
              onSubmit={handleNewsletterSubmit}
              data-readdy-form
              id="newsletter-footer-form"
            >
              <div className="form-honeypot-wrapper" aria-hidden="true">
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" readOnly />
              </div>
              <div className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setSubmitStatus('idle');
                    setFormError('');
                  }}
                  placeholder="输入你的邮箱"
                  required
                  className="flex-1 px-4 py-2.5 bg-background-800 border border-background-700 rounded-lg text-sm text-background-100 placeholder:text-background-500 focus:outline-none focus:border-primary-500 transition-colors"
                />
                <button
                  type="submit"
                  className="px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  订阅
                </button>
              </div>
              {submitStatus === 'success' && (
                <p className="text-sm text-accent-400 mt-2">订阅成功！感谢你的关注。</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-sm text-primary-400 mt-2">{formError}</p>
              )}
            </form>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 黑料社 HeiLiaoShe. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}